
import { ApiURLs } from "../../../constant/ApiUrls";
import { deleteData, fetchData, postData, updateData, uploadImage } from "../../../services/api";
import { hideAddMakeModal } from "./makeModalDispatcher";

  

  export const addMakeRequest = (data, navigate) => {
    return async (dispatch) => {
  
      // dispatch();
      dispatch({"type":"ADD_MAKE_REQUEST"});
      try {
  
    
        var makeResponse = (data.id)? await updateData(data, `${ApiURLs.VEHICLE_MAKE}/${data.id}`):await postData(data, ApiURLs.VEHICLE_MAKE);
        if (makeResponse.status === 1) {
          dispatch({"type":"ADD_MAKE_SUCCESS"});
          dispatch(hideAddMakeModal());
          dispatch(makeLisitingRequest(data["parent_id"]));
        } else {
          dispatch({"type":"ADD_MAKE_FAILED"});
        }
      } catch (error) {
        dispatch({"type":"ADD_MAKE_FAILED"});
  
      }
    };
  };




  export const makeLisitingRequest = (parentId, loadMakeDetails=false) => {

    return async (dispatch) => {

      if(parentId!=0 && loadMakeDetails==true){
        const url1 = `${ApiURLs.VEHICLE_MAKE}?id=${parentId}`;  
        try {
          var makeResponse = await fetchData(url1);
          dispatch({"type":"GOT_MAKE_DETAIL", "payload":makeResponse.data.result[0]});
          console.log("make response-------", makeResponse);
        }
        catch(e){

        }
      }
      else{
        console.log("000000000000000000000", parentId, loadMakeDetails);
        if(parentId==0){
          dispatch({"type":"GOT_MAKE_DETAIL", "payload":null});
        }
        else{
          
        }
      }
      const url = `${ApiURLs.VEHICLE_MAKE}?parent_id=${parentId}`;
  
      // wait untill the data not received so getData function take data and url part
      dispatch({"type":"GET_MAKE_REQUEST"});
      try {
        var makeResData = await fetchData(url);
        console.log(`response when we try to login ${JSON.stringify(makeResData)}`)
        if (makeResData.status === 1) {
          dispatch({"type":"GET_MAKE_REQUEST_SUCCESS", "payload":makeResData.data.result});
        
        } else {
          dispatch({"type":"GET_MAKE_REQUEST_FAILED"});
        }
      } catch (error) {
        dispatch({"type":"GET_MAKE_REQUEST_FAILED"});
        console.log(`error while try to login ${error}`)
      }
    }
  };
  


  export const getMakeListing = () => {

    return async (dispatch) => {
      const url = `${ApiURLs.VEHICLE_MAKE}`;
        try {
        var makeResData = await fetchData(url);
        console.log(`response when we try to get make ${JSON.stringify(makeResData)}`)
        if (makeResData.status === 1) {
         return makeResData.data.result;
        } else {
          return [];
        }
      } catch (error) {
        console.log(`error while try to make ${error}`)

        return [];
      }
    }
  };






  export const getModelRequest =   (makeId) => {
    return async (dispatch) => {
      dispatch({ type: "GET_MODEL_REQUEST", payload:  makeId });
  
      try {
        const url = `${ApiURLs.VEHICLE_MAKE}?makeId=$  makeId}`;
        var modelRes = await fetchData(url);
  
        if (modelRes.status === 1) {
          dispatch({
            type: "GET_MODEL_SUCCESS",
            payload: {  makeId, model: modelRes.data.result },
          });
        } else {
          dispatch({
            type: "GET_MODEL_FAILED",
            payload:  makeId,
          });
        }
      } catch (error) {
        dispatch({
          type: "GET_MODEL_FAILED",
          payload:  makeId,
        });
        console.log(`Error while fetching model: ${error}`);
      }
    };
  };




    export const deleteMake = (id, parentId) => {
      return async (dispatch) => {
   
        // dispatch();
        dispatch({"type":"ADD_MAKE_REQUEST"});
        try {
    

          var makeResponse = await deleteData(`${ApiURLs.VEHICLE_MAKE}/${id}`);
          if (makeResponse.status === 1) {
            dispatch({"type":"ADD_MAKE_SUCCESS"});
            dispatch(makeLisitingRequest(parentId));
          } else {
            dispatch({"type":"ADD_MAKE_FAILED"});
          }
        } catch (error) {
          dispatch({"type":"ADD_MAKE_FAILED"});
        }
      };
    };


  

  

